var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.OfflineOrdersHistory.Messages.GetOrderItems, Vendd.OfflineOrdersHistory, function (envelope) {
        var options = {
            url: 'api/OfflineOrdersHistory/GetOrderItems',
            data: {
                orderId: envelope.message.data,
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.OfflineOrdersHistory.Messages.GetOrderItemsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.OfflineOrdersHistory.Messages.GetOrderItemsFailure(response));
        }

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});
